module.exports = __webpack_public_path__ + "static/media/document.b9698b59.svg";